<template>
	<div>
		<div v-if="showModal">
			<teleport to="#fiche-modal">
				<div class="modal-mask modal">
					<div class="modal-wrapper" @click="showModal = false">
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox">
										<h5 class="modal-title">
											Trends
											<button type="button" class="close" @click="closeModal()">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<div class="dynvibeBox">
										<div class="col-lg-12 dynvibeTitleBox">
											<h2>Create trend</h2>
										</div>

										<div class="row dynvibeRow">
											<div class="col-md-4">
												<span style="text-transform: uppercase">Select mastertags belonging to your trend</span>
											</div>
											<div class="col-md-6">
												<select class="dynvibeSelect" v-model="createSelectedMastertag">
													<option v-for="(mastertag, index) in allMastertags" :key="index" :value="mastertag">
														{{ mastertag }}
													</option>
												</select>
												<span @click="addMastertagOnCreateList" class="dynvibePlus icon-plus"></span>
											</div>
											<div class="col-md-2"></div>
										</div>
										<div class="row dynvibeRow">
											<div
												class="dynvibeRuleTag"
												v-for="mastertag in createAddedMastertags"
												:key="'added_' + mastertag"
											>
												<div>
													<span>{{ mastertag }}</span>
													<i @click="createRemoveMastertag(mastertag)" class="dynvibeRuleSepRemove icon-x"></i>
												</div>
											</div>
										</div>
										<div class="row dynvibeRow">
											<div class="col-md-4">
												<span style="text-transform: uppercase">Trend name</span>
											</div>
											<div class="col-md-6">
												<input class="modalInput" type="text" v-model="createTrendName" />
											</div>
											<div class="col-md-2">
												<button
													class="btn-success dynvibeModalFooterBtn dynvibeModalFooterBtnApply"
													@click="createTrend"
												>
													Create trend
												</button>
											</div>
										</div>
									</div>

									<div class="dynvibeBox">
										<div class="col-lg-12 dynvibeTitleBox">
											<h2>Edit trend</h2>
										</div>

										<div class="row dynvibeRow">
											<div class="col-md-4">
												<span style="text-transform: uppercase">Select a trend</span>
											</div>
											<div class="col-md-6">
												<select class="dynvibeSelect" v-model="selectedTrend" @change="updateSelectedTrend">
													<option v-for="(trend, index) in allTrends" :key="index" :value="trend.label">
														{{ trend.label }}
													</option>
												</select>
											</div>
											<div class="col-md-2"></div>
										</div>
										<div class="row dynvibeRow">
											<div class="col-md-4">
												<span style="text-transform: uppercase">Edit name if necessary</span>
											</div>
											<div class="col-md-6">
												<input class="modalInput" type="text" v-model="newName" />
											</div>
										</div>
										<div class="row dynvibeRow">
											<div class="col-md-4">
												<span style="text-transform: uppercase">Select mastertags you want to add</span>
											</div>
											<div class="col-md-6">
												<select class="dynvibeSelect" style="min-width: 150px" v-model="editSelectedMastertag">
													<option v-for="(mastertag, index) in allMastertags" :key="index" :value="mastertag">
														{{ mastertag }}
													</option>
												</select>
												<span @click="addMastertagOnEditList" class="dynvibePlus icon-plus"></span>
											</div>
											<div class="col-md-2"></div>
										</div>
										<div class="row dynvibeRow">
											<div
												class="dynvibeRuleTag"
												v-for="mastertag in editAddedMastertags"
												:key="'added_' + mastertag"
											>
												<div>
													<span>{{ mastertag }}</span>
													<i @click="editRemoveMastertag(mastertag)" class="dynvibeRuleSepRemove icon-x"></i>
												</div>
											</div>
										</div>

										<div class="row dynvibeRow">
											<div class="col-md-offset-10 col-md-2">
												<button
													class="btn-success dynvibeModalFooterBtn dynvibeModalFooterBtnApply"
													@click="editTrend"
												>
													Edit trend
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
					<template v-slot:confirm-body>{{ confirmMessage }}</template>
				</confirm>
			</teleport>
		</div>
	</div>
</template>
<script>
import confirm from "@/components/globalVue/Confirm.vue";

export default {
	name: "editcreatemodal",
	props: {},
	components: {
		confirm: confirm,
	},
	emits: ["updatetrends"],
	data() {
		return {
			showModal: false,
			allMastertags: [],
			createAddedMastertags: [], // added mastertags for Create trednd
			createSelectedMastertag: "", // selected mastertag for create trend
			createTrendName: "", // name of the input of create trend
			allTrends: [],
			editSelectedMastertag: "",
			editAddedMastertags: [],
			selectedTrend: "",
			newName: "",
			type: "mastertags",
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
		};
	},
	mounted: function () {},
	methods: {
		loadComponent() {
			this.getData("getListMtCat", { type: this.type });
			this.allTrends = [];
		},
		treatResponse(response) {
			this.allMastertags = response.data.data.map((mastertag) => mastertag.data.label);
		},
		loadData() {
			this.$axios.get(this.$backendUrl + "getListTrends").then((response) => {
				this.allTrends = response.data.data.map((obj) => {
					let trend = {};
					trend["label"] = obj.label;
					trend["mastertags"] = obj.mastertags;
					return trend;
				});
			});

			this.createAddedMastertags = [];
			this.createTrendName = "";
			this.createSelectedMastertag = "";
			this.editSelectedMastertag;
			this.editAddedMastertags = [];
			this.selectedTrend = "";
			this.editSelectedMastertag = "";
			this.newName = "";
			this.showModal = true;
		},
		show() {
			this.loadData();
		},
		closeModal() {
			this.showModal = false;
		},
		addMastertagOnCreateList() {
			if (this.createSelectedMastertag === "") {
				return;
			}
			if (this.createAddedMastertags.includes(this.createSelectedMastertag) === false) {
				this.createAddedMastertags.push(this.createSelectedMastertag);
			}
		},
		createRemoveMastertag(mastertag) {
			this.createAddedMastertags = this.createAddedMastertags.filter((item) => item !== mastertag);
		},
		createTrend() {
			if (!this.createTrendName || this.createTrendName === "") {
				this.confirmErrorModal("Trend name is empty");
				return;
			}
			if (this.createAddedMastertags.length === 0) {
				this.confirmErrorModal("No mastertag added");
				return;
			}

			let params = {
				label: this.createTrendName,
				mastertags: this.createAddedMastertags,
			};
			this.$axios.post(this.$backendUrl + "trendAdd", this.$Qs.stringify(params)).then((response) => {
				if (response.data.isOk === 1) {
					this.confirmSuccessModal(this.createTrendName + " has been created.");
				} else {
					this.confirmErrorModal(response.data.error);
				}
			});
		},
		updateSelectedTrend() {
			for (let i = 0; i < this.allTrends.length; i++) {
				if (this.allTrends[i]["label"] === this.selectedTrend) {
					this.editAddedMastertags = this.allTrends[i]["mastertags"];
				}
			}
			this.newName = this.selectedTrend;
		},
		addMastertagOnEditList() {
			if (this.editAddedMastertags === "") {
				return;
			}
			if (this.editAddedMastertags.includes(this.editSelectedMastertag) === false) {
				this.editAddedMastertags.push(this.editSelectedMastertag);
			}
		},
		editTrend() {
			if (this.selectedTrend === "") {
				this.confirmErrorModal("No trend selected");
				return;
			}

			if (this.editAddedMastertags.length === 0) {
				this.confirmErrorModal("No mastertag added");
				return;
			}

			let params = {
				oldLabel: this.selectedTrend,
				newLabel: this.newName,
				mastertags: this.editAddedMastertags,
			};
			this.$axios.post(this.$backendUrl + "trendEdit", this.$Qs.stringify(params)).then((response) => {
				if (response.data.isOk === 1) {
					this.confirmSuccessModal(this.selectedTrend + " has been edited.");
					this.loadData();
				} else {
					this.confirmErrorModal(response.data.error);
				}
			});
		},
		editRemoveMastertag(mastertag) {
			this.editAddedMastertags = this.editAddedMastertags.filter((item) => item !== mastertag);
		},
	},
	watch: {
		showModal(newValue) {
			if (newValue === false) {
				this.$emit("updatetrends");
			}
		},
	},
};
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeButtonIcon {
	margin-left: 0;
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}
}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

.dynvibeSelect {
	min-width: 150px;
	max-width: 90%;
}

.dynvibeBox {
	min-height: 100px;
}

.modal-header > .dynvibeTitleBox {
	padding-bottom: 5px;
}

.dynvibeTitleBox {
	padding-bottom: 0;
	margin-bottom: 20px;
}

.dynvibePlus {
	font-size: 10px;
	padding: 5px;
	border-radius: 50%;
	color: #fff;
	background-color: #8e8e8e;
	cursor: pointer;
	height: 20px;
	margin-right: 5px;
	margin-left: 5px;
}

.dynvibeModalFooterBtn {
	padding: 5px;
}

.modalInput {
	height: 31px;
	width: 90%;
	border-radius: 12px;
	border: 1px solid #cacaca;
	color: #8e8e8e;
}

.modalInput:focus,
.modalInput:focus-visible {
	outline: none;
}
</style>
